<template>
  <div class="sections-navbar hidden-print">
    <affix :relative-element-selector="relativeElementSelector" v-if="sections" :offset="{ top: affixOffset, bottom: -2000 }">
      <template>
        <div class="visible-xs visible-sm container">
          <div class="travel-detail-section-dropdown row">
            <div class="dropdown">
              <scrollactive :id="context + '-sections-dorpdown-nav'"
                            class="sections-dropdown-nav nav"
                            :offset="affixOffset"
                            :highlightFirstItem="true"
                            :modify-url="false"
                            :alwaysTrack="true"
                            v-on:itemchange="selectDropdownItem">
                <template>
                  <div class="dropdown-button-wrapper" v-on:click="toggleDropdown">
                    <a v-for="(s, key) in sections"
                       :href="'#section-'+ key"
                       class="btn dropdown-btn scrollactive-item"
                       type="button" style="display: none; pointer-events: none;">{{ s }}
                      <i class="icon inline very-small icon-arrow-bottom"></i>
                    </a>
                  </div>
                  <ul id="travel-detail-jumpbar-menu" v-if="showJumpbarDropdown" class="dropdown-menu"
                      aria-labelledby="dLabel">
                    <li class="" v-for="(s, key) in sections">
                      <a class="sections-navbar-dropdown-item scrollactive-item" :href="'#section-'+key" v-on:click.passive="selectDropdownItem(key)">{{ s }}</a>
                    </li>
                  </ul>
                </template>
              </scrollactive>
              <a class="btn btn-primary btn-inline pull-right highlight-button" :href="buchenLink" :disabled="!buchenLink?true:false">
                {{ buchenText }}
              </a>
            </div>
          </div>
        </div>
        <div class="visible-md visible-lg">
          <div class="travel-detail-section">
            <div class="container">
              <div class="row">
                <div class="col-xs-12">
                  <scrollactive :id="context + '-sections-nav'" class="sections-nav nav"
                                :offset="affixOffset"
                                :highlightFirstItem="true"
                                :alwaysTrack="true"
                                :modify-url="false">
                    <ul class="list-inline">
                      <li class="" v-for="(s, key) in sections">
                        <a class="btn btn-transparent btn-inline sections-navbar-item scrollactive-item"
                           :href="'#section-'+key"><span>{{ s }}</span></a>
                      </li>
                      <li>
                        <a class="btn btn-primary highlight-button" :href="buchenLink" :disabled="!buchenLink?true:false">
                          <span>{{ buchenText }}</span>
                        </a>
                      </li>
                    </ul>
                  </scrollactive>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </affix>
  </div>
</template>
<style></style>
<script type="module">
export default {
  name: "sections-navbar",
  props: {
    sections: {
      type: [Array],
      default: []
    },
    relativeElementSelector: {
      type: String,
      default: 'main'
    },
    buchenText: {
      type: String,
      default: 'Reise buchen'
    },
    buchenLink: null,
    showJumpbarDropdown: false,
    context: String,
  },
  mixins: [],
  data: function () {
    return {
      affixOffset: false,
      currentBreakpoint: 'xs',
      breakpoints: {
        xl: 1600,
        lg: 1200,
        md: 992,
        sm: 768,
        xs: 0
      }
    }
  },
  created() {
    window.addEventListener("resize", this.determineAffixOffset);
  },
  destroyed() {
    window.removeEventListener("resize", this.determineAffixOffset);
  },
  mounted(){
    this.determineAffixOffset();
  },
  methods: {
    toggleDropdown: function (e) {
      this.showJumpbarDropdown = !this.showJumpbarDropdown;
    },
    selectDropdownItem: function (key) {
      this.showJumpbarDropdown = false;
    },
    determineAffixOffset: function() {
      var w = window.innerWidth;
      for (const [key, value] of Object.entries(this.breakpoints)) {
        if(w >= value){
          this.currentBreakpoint = key;
          break;
        }
      }
      if(this.currentBreakpoint == 'xs')this.affixOffset = 130;
      if(this.currentBreakpoint == 'sm')this.affixOffset = 130;
      if(this.currentBreakpoint == 'md')this.affixOffset = 165;
      if(this.currentBreakpoint == 'lg')this.affixOffset = 165;
      if(this.currentBreakpoint == 'xl')this.affixOffset = 165;
    }
  }
}
</script>